<template>
  <section class="change-section" :class="{ 'is-active': isActive }">
    <!-- 배경 -->
    <div class="bg">
      <div class="bg-image-wrap">
        <img src="@/assets/beyond.jpg" class="bg-image" alt="" />
      </div>
      <div class="bg-gradient"></div>
    </div>

    <!-- 중앙 콘텐츠 -->
    <div class="center">
      <!-- GREAT CHANGE -->
      <h2 class="title-main" :class="{ show: isActive }">
        <span class="title-word" v-for="(letter, i) in 'BEYOND PREMIUM'.split('')" :key="'t'+i"
          :style="{ '--i': i }"
          :class="{ 'is-space': letter === ' ' }"
        >{{ letter }}</span>
      </h2>

      <!-- 서브타이틀 -->
      <p class="title-sub" :class="{ show: isActive }">DOUBLE LIFE, DOUBLE VALUE</p>

      <!-- 구분선 -->
      <div class="divider" :class="{ show: isActive }"></div>

      <!-- 한글 본문 -->
      <div class="body-text" :class="{ show: isActive }">
        <p class="body-line" v-for="(line, idx) in bodyLines" :key="idx"
          :style="{ '--line-delay': (3.0 + idx * 0.2) + 's' }"
        >{{ line }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ChangeSection',
  props: {
    isActive: { type: Boolean, default: false }
  },
  data() {
    return {
      bodyLines: [
        '김천과 구미를 잇는 더블생활권의 시작',
        '',
        '출근길은 더 가벼워지고, 퇴근 후의 여유는 더 깊어집니다.',
        '자연의 힐링과 도심의 혜택이 공존하는 736세대 에코 랜드마크에서',
        '당신이 꿈꾸던 내일이 가장 먼저 시작됩니다.'
      ]
    }
  }
}
</script>

<style scoped>
.change-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #080c14;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ===== 배경 ===== */
.bg {
  position: absolute;
  inset: 0;
}

/* 가로 꽉 채우는 이미지 (세로는 넘치면 자름) */
.bg-image-wrap {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.bg-image {
  position: absolute;
  top: -85%;
  left: 0;
  width: 100%;
  height: auto;
  display: block;
  opacity: 0.2;
  mask-image: linear-gradient(to bottom, #000 0%, #000 55%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, #000 0%, #000 55%, transparent 100%);
}

.bg-gradient {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 50% 70%, rgba(20, 28, 50, 0.3) 0%, rgba(8, 12, 20, 0) 60%);
  pointer-events: none;
}

/* ===== 중앙 ===== */
.center {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 0 40px;
}

/* ===== GREAT CHANGE ===== */
.title-main {
  margin: 0 0 16px;
  overflow: hidden;
}

.title-word {
  display: inline-block;
  font-family: var(--font-serif);
  font-size: clamp(56px, 6vw, 100px);
  font-weight: 700;
  color: #fff;
  letter-spacing: 80px;
  opacity: 0;
  transition: opacity 1.2s ease, letter-spacing 2.5s cubic-bezier(0.22, 1, 0.36, 1);
  transition-delay: 0.3s;
}

.title-word.is-space {
  width: 28px;
}

.title-main.show .title-word {
  opacity: 1;
  letter-spacing: 12px;
}

/* ===== 서브타이틀 ===== */
.title-sub {
  font-family: var(--font-serif);
  font-size: clamp(16px, 1.6vw, 24px);
  font-weight: 400;
  font-style: italic;
  color: rgba(255, 255, 255, 0.35);
  letter-spacing: 6px;
  margin: 0 0 40px;
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 1s ease, transform 1s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: 1.5s;
}

.title-sub.show {
  opacity: 1;
  transform: translateY(0);
}

/* ===== 구분선 ===== */
.divider {
  width: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
  margin: 0 auto 44px;
  transition: width 1s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: 2.5s;
}

.divider.show {
  width: 80px;
}

/* ===== 한글 본문 ===== */
.body-text {
  max-width: 600px;
  margin: 0 auto;
}

.body-line {
  font-family: var(--font-pretendard);
  font-size: 23px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.8);
  line-height: 2.2;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.7s ease, transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: var(--line-delay);
}

.body-text.show .body-line {
  opacity: 1;
  transform: translateY(0);
}

/* ===== 반응형 - 태블릿 (1024px) ===== */
@media (max-width: 1024px) {
  .center {
    padding: 0 32px;
  }

  .title-word {
    font-size: clamp(44px, 5.5vw, 80px);
    letter-spacing: 50px;
  }

  .title-main.show .title-word {
    letter-spacing: 10px;
  }

  .title-word.is-space {
    width: 22px;
  }

  .title-sub {
    font-size: clamp(14px, 1.5vw, 20px);
    letter-spacing: 5px;
    margin: 0 0 32px;
  }

  .divider {
    margin: 0 auto 36px;
  }

  .body-line {
    font-size: 20px;
    line-height: 2;
  }
}

/* ===== 반응형 - 900px ===== */
@media (max-width: 900px) {
  .title-word {
    letter-spacing: 20px;
  }

  .title-main.show .title-word {
    letter-spacing: 6px;
  }

  .sub-word {
    letter-spacing: 16px;
  }

  .title-sub.show .sub-word {
    letter-spacing: 4px;
  }

  .body-line {
    font-size: 18px;
  }
}

/* ===== 반응형 - 모바일 (768px) ===== */
@media (max-width: 768px) {
  .change-section {
    height: auto;
    min-height: 100vh;
    padding: 100px 0 80px;
  }

  /* 모바일: 이미지 전체 노출 (cover로 꽉 채움) */
  .bg-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.35;
    mask-image: linear-gradient(to bottom, #000 0%, #000 70%, rgba(0, 0, 0, 0.2) 100%);
    -webkit-mask-image: linear-gradient(to bottom, #000 0%, #000 70%, rgba(0, 0, 0, 0.2) 100%);
  }

  .center {
    padding: 0 24px;
    width: 100%;
    box-sizing: border-box;
  }

  /* 메인 타이틀 */
  .title-main {
    margin: 0 0 12px;
  }

  .title-word {
    font-size: clamp(28px, 7vw, 44px);
    letter-spacing: 16px;
    transition: opacity 1s ease, letter-spacing 2s cubic-bezier(0.22, 1, 0.36, 1);
    transition-delay: 0.2s;
  }

  .title-word.is-space {
    width: 14px;
  }

  .title-main.show .title-word {
    letter-spacing: 4px;
  }

  /* 서브타이틀 */
  .title-sub {
    font-size: clamp(13px, 3.2vw, 17px);
    letter-spacing: 3px;
    margin: 0 0 24px;
    transform: translateY(16px);
    transition-delay: 1.2s;
    color: rgba(255, 255, 255, 0.55);
  }

  /* 구분선 */
  .divider {
    margin: 0 auto 28px;
    transition-delay: 2s;
  }

  .divider.show {
    width: 50px;
  }

  /* 한글 본문 */
  .body-text {
    max-width: 100%;
    padding: 0 4px;
  }

  .body-line {
    font-size: 17px;
    line-height: 1.9;
    transform: translateY(14px);
    word-break: keep-all;
    color: rgba(255, 255, 255, 0.85);
  }
}

/* ===== 반응형 - 소형 모바일 (480px) ===== */
@media (max-width: 480px) {
  .center {
    padding: 0 20px;
  }

  .title-word {
    font-size: clamp(24px, 7vw, 36px);
    letter-spacing: 12px;
  }

  .title-main.show .title-word {
    letter-spacing: 3px;
  }

  .title-word.is-space {
    width: 10px;
  }

  .title-sub {
    font-size: clamp(12px, 3vw, 15px);
    letter-spacing: 2px;
    margin: 0 0 20px;
  }

  .divider {
    margin: 0 auto 24px;
  }

  .divider.show {
    width: 40px;
  }

  .body-line {
    font-size: 14px;
    line-height: 1.85;
  }
}
</style>
